import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../../modules/shared/services/shared.service";
import { SessionWidgetService } from "../../../../../../../modules/shared/services/session-widget.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "widget-text-config-page",
    templateUrl: "./widget-text-config-page.view.html",
    providers: []
})
export class WidgetTextConfigPageView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    sessionWidgetConfig: any = {};
    widgetCatalogConfiguration: any = {};
    widgetTextConfiguration: any = {};
    objectKeys = Object.keys;

    constructor(public sharedService: SharedService,
        private sessionWidgetService: SessionWidgetService,
         private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            this.sessionWidgetConfig = this.sharedService.sessionLayoutConfig[this.baseUrl];
            this.expansionStyle = this.sharedService.expansionStyle;
            this.loadTextConfiguration();
        }
    }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            this.sessionWidgetConfig = this.sharedService.sessionLayoutConfig[this.baseUrl];
            this.expansionStyle = this.sharedService.expansionStyle;
            this.loadTextConfiguration();
        }
    }

    resetLoading: boolean = false;

    resetLabelConfiguration() {
        this.resetLoading = true;
        setTimeout(() => {
            this.loadDefaultTextConfiguration();
            this.resetLoading = false;
        }, 1000);
    }

    loadTextConfiguration() {
        this.widgetTextConfiguration = this.sessionWidgetConfig.widget.applyCatalogConfiguration ? this.sessionWidgetConfig.widget.text : this.sessionWidgetConfig.widget.widgetConfiguration.labels;
        if(this.widgetTextConfiguration == null) {
            this.loadDefaultTextConfiguration();
        }
    }

    loadDefaultTextConfiguration() {
        let textConfiguration = {
            'title': 'Recommendation for you',
            'addToSchedule': 'Add to Schedule',
            'similarSessions': 'Similar sessions',
            'recommendationDetails': 'Details',
            'recommendationsToReview': 'You have new recommendations to review.',
            'recommendationsToReviewClick': 'Click here to see them.',
            'replaceSchedule': 'Replace Schedule',
            'overlapSchedule': 'Replace Schedule',
            'waitlistSchedule': 'Join Waitlist',
            'popularSearchLabel': 'Popular Search:',
            'similarSessionsButton': 'Similar sessions',
            'similarSessionsTitle': "Sessions similar to [title]",
            'confirmButton': 'Confirm',
            'cancelButton': 'Cancel',
            'myScheduleButton': 'My Schedule',
            'myScheduleTitle': 'Conference Schedule',
            'myScheduleSubTitle': 'Manage your personalized conference schedule',
            'myScheduleColumn': 'My Schedule',
            'myScheduleRecommendationColumn': 'Recommendations',
            'myScheduleFillTheDayButton': 'Fill the Day',
            'myScheduleAvailableSessionsTitle': 'Available Sessions',
        };

        this.sessionWidgetConfig.widget.text = textConfiguration;
        this.widgetTextConfiguration = this.sessionWidgetConfig.widget.text;        
    }

    formatConfigurationKeyDisplay (inputItem: string): string {
        return inputItem
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase()).trim();
    }

    toggleApplyCatalogConfiguration(ev) {
        this.sessionWidgetConfig.widget.applyCatalogConfiguration = !this.sessionWidgetConfig.widget.applyCatalogConfiguration;
        this.loadTextConfiguration();
    }
}
